import { Box, Grid } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { parseMedicalInformationStatus } from '../func/parse';
import { MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME, STATUS_COLOR } from '../constants/constants';
import { useMedicalHealthInformationContext } from '../Context';

// カードの横幅
const listCardWidth = 353;

const MedicalHealthInformationBranch = () => {
  const { setActiveStep, activeMedicalHealthInformation } = useMedicalHealthInformationContext();
  const status = parseMedicalInformationStatus(activeMedicalHealthInformation);
  const handleCardClick = () => {
    setActiveStep(MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME);
  };

  return (
    <Box sx={{ marginTop: '16px' }}>
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container spacing={2} sx={{ paddingX: '20px', maxWidth: `calc(${listCardWidth}px *2 + 20px)` }}>
            <Grid item xs={12} md={6} sx={{ width: `${listCardWidth}px`, justifyContent: 'center', display: 'flex' }}>
              <button
                onClick={handleCardClick}
                type="button"
                style={{
                  width: `${listCardWidth}px`,
                  padding: '18px 0',
                  backgroundColor: 'white',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  fontSize: '18px',
                  lineHeight: '1.5',
                  fontWeight: 'bold'
                }}
              >
                問診
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    position: 'absolute',
                    right: '4px',
                    top: '50%',
                    transform: 'translateY(-50%)'
                  }}
                >
                  {status && (
                    <Box sx={{ fontSize: '10px', lineHeight: '1.5', fontWeight: 'bold' }}>
                      <span style={STATUS_COLOR[status]}>{status}</span>
                    </Box>
                  )}
                  <ArrowForwardIosIcon />
                </Box>
              </button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={0} md={3} sm={2} />
      </Grid>
    </Box>
  );
};
export default MedicalHealthInformationBranch;
